import React, { useEffect } from 'react'
import {Typography,Button, Grid} from '@mui/material';
import colors from '../../../../colors'
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { displayInvoiceList, resetTaksatSlice, selectTaksatState, changeConfirmationDialogState } from '../../../../../features/taksat/taksatSlice';
import {sendGeneralRequest} from '../../../../../features/generalRequest'
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import {  selectBasicAccountState, setShouldBasicAccountPaymentRun, setTransactionIdToCancel } from '../../../../../features/basicAccount/basicAccountSlice';
import { runBasicAccountPayment } from '../../../../general/BasicAccountMethods';
import ConfirmationDialog from '../../../../general/ConfirmationDialog'
import { texts } from '../../../../general/texts';
import { useLocation } from 'react-router-dom';
import { selectUtilityState } from '../../../../../features/utilities/utilitySlice';


const SingleExpandedInvoice = (props) => 
{
    const dispatch = useDispatch()
    const state = props.invoice
    const userInfo = useSelector(selectUserInfo)
    const basicAccountSliceState = useSelector(selectBasicAccountState)
    const taksatSliceState = useSelector(selectTaksatState)
    const utilitySliceState = useSelector(selectUtilityState)
    const location = useLocation();
    const handleBackButton = () => 
    {
        dispatch(setShouldBasicAccountPaymentRun(false))
        dispatch(resetTaksatSlice())
    }

    const handleConfirmation = () => 
    {
        dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.taksatSliceState.transactionId, service: props.utilityName, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true }, baseUrlKey:'services', endpoint:'DPTTV/ConfirmTransactionTaxesTirana'}))
    }

    const handleButtonClick = () =>{
        if(props.taksatSliceState.isTransactionSuccessfullyStarted){

            if(userInfo.accountType === 3)
            {   
                dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, paymentMethod:'2', applicationID:1, value: Number(taksatSliceState.singleInvoice["Vlera Totale"]), transID: props.taksatSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
                dispatch(setTransactionIdToCancel(props.taksatSliceState.transactionId))
            }
            else
            {
                dispatch(changeConfirmationDialogState())
            }
            // userInfo.accountType === 3
            // ? dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, paymentMethod:'2', applicationID:1, value: Number(state.value), transID: props.taksatSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
            // : dispatch(changeConfirmationDialogState())
        }
    }

    useEffect(() => {
        const handleLocationChange = () => {
            dispatch(setShouldBasicAccountPaymentRun(false));
        };
    
        handleLocationChange(); // Initial call to handle location on mount
    
        return () => {
            handleLocationChange(); // Call on unmount
        };
    }, [location, dispatch]);

    return(
        <>      
            <Grid container justifyContent={'center'} p={3}> 
                {
                basicAccountSliceState.shouldBasicAccountPaymentRun 
                ? 
                    runBasicAccountPayment(
                            dispatch,
                            basicAccountSliceState.basicAccountPaymentUrl,
                            {request: {token: props.globalDataSliceState.token, transID: props.taksatSliceState.transactionId, service: props.utilityName, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint:'DPTTV/ConfirmTransactionTaxesTirana'},
                            {request: {token: props.globalDataSliceState.token, orderId: props.taksatSliceState.transactionId}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'},
                            handleBackButton
                        ) 
                :
                <> 
                <Grid container pb={'3%'}>
                    <Grid item md={10} xs={10} ></Grid>
                    <Grid item md={2} xs={2} pt={'1%'} ><Button onClick={()=>{dispatch(displayInvoiceList())}} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                </Grid>         
                    <Grid container md={12} pb={'10%'} item > 
                        {Object.entries(state).map(([key,value]) => {
                            return <Grid container item md={12} pb={'5%'} pr={'5%'}>
                                <Grid container item justifyContent='flex-start' md={6}><Typography style={{color: colors.darkBlue, fontFamily:'GerberaBold', fontSize:'1.9vh'}}>{key}</Typography></Grid>
                                <Grid container item justifyContent='flex-end' md={6}><Typography style={{color: colors.gray, fontSize:'1.8vh', fontFamily:'GerberaLight'}}>{value}</Typography></Grid>
                            </Grid> 
                        })}                                                                                                                         
                    </Grid>
                    <Grid container item justifyContent={'center'} pb={'2%'} md={12}>
                        <Button disabled={taksatSliceState.isLoading ? true : false} onClick={handleButtonClick} style={{background:colors.gradientOrange ,width:'100%', color:colors.white, fontFamily:'GerberaBold'}}>{texts["title-pay"]}</Button>        
                    </Grid>
                    </>   
            }                                                   
            </Grid>
            {taksatSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={taksatSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}      
        </>             
    )
}
export default SingleExpandedInvoice